<template>
	<v-row dense>
		<v-col cols="12">
			<v-autocomplete
				item-value="id"
				:item-text="ownerText"
				placeholder="Búsqueda de proveedor"
				dense
				outlined
				return-object
				hide-details
				clearable
				:value="owner"
				:items="owners"
				:loading="loading"
				:rules="required ? requiredRule : []"
				@input="(v) => setValue(v)"
			>
			</v-autocomplete>
		</v-col>
		<v-col cols="12" md="auto">
			<v-btn color="primary" class="text-none" text @click="dialog = true">
				<v-icon left> mdi-account-plus </v-icon>
				Agregar proveedor
			</v-btn>
			<create-owner-dialog v-model="dialog" fixed-type="PROVIDER" @success="refreshOwners" />
		</v-col>
	</v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CreateOwnerDialog from '@/components/contract/create/elements/CreateOwnerDialog/CreateOwnerDialog.vue';

export default {
	name: 'SupplierSearch',
	props: {
		value: {
			type: [Object, Number, String],
			required: false,
		},
		required: {
			type: Boolean,
			required: false,
		},
	},
	data: () => ({
		loading: false,
		dialog: false,
		requiredRule: [(v) => !!v || 'Campo requerido'],
	}),
	async created() {
		this.loading = true;
		await this.listOwners({ type: 'PROVIDER' });
		this.loading = false;
	},
	computed: {
		...mapState('owner', ['owners']),
		owner: {
			get() {
				return this.value || null;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
	},

	watch: {},
	methods: {
		...mapActions('owner', ['listOwners']),
		ownerText(item) {
			return item.document ? `${item.name} - ${item.document}` : item.name;
		},
		setValue(value) {
			this.$emit('input', value);
		},
		async refreshOwners() {
			this.loading = true;
			await this.listOwners({ type: 'PROVIDER' });
			this.loading = false;
		},
	},
	destroyed() {},
	components: {
		CreateOwnerDialog,
	},
};
</script>
